// The start-page greeting (docs/HOME-2026-10.md, F2). Pure: same inputs, same words.
// o = { name, touches, back, bellDays }. First matching rule wins.
export function greetingFor(now, o = {}) {
	const name = String(o.name || "").trim().slice(0, 40);
	const sfx = name ? ", " + name : "";
	const h = now.getHours(), day = now.getDay();
	const plain = (h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening") + sfx;
	if (o.touches === false) return plain;
	if (h >= 22 || h < 5) return "Studying late" + sfx + "? Rest counts too.";
	if (o.back) return "Welcome back" + sfx;
	const school = Array.isArray(o.bellDays) ? o.bellDays : [];
	if (day === 6 && !school.includes(6)) return "Happy Saturday" + sfx;
	if (day === 0 && !school.includes(0)) return "Easy Sunday" + sfx;
	if (day === 5 && h >= 12) return "Happy Friday" + sfx;
	return plain;
}
